module.exports = __webpack_public_path__ + "h5/img/live.6503beac.png";